export default function getErrorMessage(error, fallbackMessage = 'Something went wrong') {
  if (Array.isArray(error?.response?.data)) {
    return error.response.data[0];
  }

  if (typeof error?.response?.data === 'string') {
    return error.response.data;
  }

  if (typeof error?.response?.data?.message === 'string') {
    return error.response.data.message;
  }

  if (typeof error?.message === 'string') {
    return error.message;
  }

  return fallbackMessage;
}
